var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncertainG2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4212_1680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#383A36"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4212_1680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FC8E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09943 15.321V13.7699L10.7237 10.4141C11.032 10.1158 11.2905 9.8473 11.4993 9.60866C11.7114 9.37003 11.8722 9.13636 11.9815 8.90767C12.0909 8.67566 12.1456 8.42543 12.1456 8.15696C12.1456 7.85866 12.0777 7.6018 11.9418 7.38636C11.8059 7.16761 11.6203 7.00024 11.3849 6.88423C11.1496 6.76491 10.8828 6.70526 10.5845 6.70526C10.273 6.70526 10.0012 6.76823 9.76918 6.89418C9.53717 7.02012 9.35819 7.20076 9.23224 7.43608C9.1063 7.6714 9.04332 7.95147 9.04332 8.27628H7C7 7.61009 7.1508 7.03172 7.45241 6.54119C7.75402 6.05066 8.17661 5.67116 8.72017 5.4027C9.26373 5.13423 9.89015 5 10.5994 5C11.3286 5 11.9633 5.12926 12.5036 5.38778C13.0471 5.64299 13.4697 5.99763 13.7713 6.4517C14.0729 6.90578 14.2237 7.42614 14.2237 8.01278C14.2237 8.39725 14.1475 8.77675 13.995 9.15128C13.8459 9.5258 13.5791 9.94176 13.1946 10.3991C12.8101 10.8532 12.2682 11.3984 11.5689 12.0348L10.0824 13.4915V13.5611H14.358V15.321H7.09943Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4212_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncertainG2);
export default __webpack_public_path__ + "static/media/uncertainG2.3a7be666e947722de29e66428ee9cd66.svg";
export { ForwardRef as ReactComponent };